import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonicalUrl?: string;
  ogType?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
  twitterCard?: string;
  twitterTitle?: string;
  twitterDescription?: string;
  twitterImage?: string;
}

const defaultDescription = "Transform your data between various formats including JSON, CSV, SQL, XML, and YAML with our free online data converters.";
const defaultKeywords = "data converter, json to csv, csv to json, sql formatter, xml formatter, yaml converter";
const siteUrl = "https://formatally.com"; // Replace with your actual domain

const SEO: React.FC<SEOProps> = ({
  title = "Data Converters | Free Online Data Format Conversion Tools",
  description = defaultDescription,
  keywords = defaultKeywords,
  canonicalUrl = siteUrl,
  ogType = "website",
  ogTitle,
  ogDescription,
  ogImage = `${siteUrl}/images/og-image.png`, // Replace with your actual OG image path
  twitterCard = "summary_large_image",
  twitterTitle,
  twitterDescription,
  twitterImage
}) => {
  // Use provided values or fall back to defaults
  const metaTitle = title;
  const metaDescription = description;
  const metaOgTitle = ogTitle || title;
  const metaOgDescription = ogDescription || description;
  const metaTwitterTitle = twitterTitle || title;
  const metaTwitterDescription = twitterDescription || description;
  const metaTwitterImage = twitterImage || ogImage;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{metaTitle}</title>
      <meta name="description" content={metaDescription} />
      <meta name="keywords" content={keywords} />
      
      {/* Canonical Link */}
      <link rel="canonical" href={canonicalUrl} />
      
      {/* Open Graph Meta Tags */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={metaOgTitle} />
      <meta property="og:description" content={metaOgDescription} />
      <meta property="og:image" content={ogImage} />
      
      {/* Twitter Card Meta Tags */}
      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:title" content={metaTwitterTitle} />
      <meta name="twitter:description" content={metaTwitterDescription} />
      <meta name="twitter:image" content={metaTwitterImage} />
    </Helmet>
  );
};

export default SEO;